var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertTriangleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.634 1.5C14.0189 0.833332 14.9811 0.833333 15.366 1.5L26.1913 20.25C26.5762 20.9167 26.0951 21.75 25.3253 21.75H3.67468C2.90488 21.75 2.42376 20.9167 2.80866 20.25L13.634 1.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5053 8.75781L15.2958 15.1753H13.7724L13.5565 8.75781H15.5053ZM13.5058 17.1621C13.5058 16.8913 13.5989 16.667 13.785 16.4893C13.9755 16.3073 14.2252 16.2163 14.5341 16.2163C14.8472 16.2163 15.0969 16.3073 15.2831 16.4893C15.4693 16.667 15.5624 16.8913 15.5624 17.1621C15.5624 17.4245 15.4693 17.6466 15.2831 17.8286C15.0969 18.0106 14.8472 18.1016 14.5341 18.1016C14.2252 18.1016 13.9755 18.0106 13.785 17.8286C13.5989 17.6466 13.5058 17.4245 13.5058 17.1621Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangleIcon);
export default __webpack_public_path__ + "static/media/alert-triangle-icon.f825be86.svg";
export { ForwardRef as ReactComponent };